//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FullScreenRotation from "@/components/FullScreenRotation";
export default {
  props: ["index"],
  data() {
    return {};
  },
  methods: {
    closeModal() {
      //   alert(1);
      this.$emit("modalFrameClick", false);
      this.$store.dispatch("showHeader", true);
    },
    hiddenModal() {
      this.closeModal();
    }
  },
  components: {
    FullScreenRotation
  },
  mounted() {
    this.$refs.modalWrapOut.addEventListener("click", e => {
      const str = e.target.className;
      if (window.innerWidth > 700) {
        if (str.includes("lg-outer")) {
          this.closeModal();
        }
      } else {
        if (str.includes("lg-inner")) {
          // alert(12);
          this.closeModal();
        }
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/views/Home/modalFrame.vue